export default class ModalContent {
  constructor(content) {
    this.content = {
      title: content.title || '',
      message: content.message || '',
      button: content.button || false,
    };
  }
}
